import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  getData,
  getColumns, getIsLoading,
} from '../redux/selectors/UserListingSelectors';
import ListTable from '../../../../common/tables/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import DownloadTypes from '../../../../common/tables/excel/DownloadTypes';

function UserListingContainer(props) {
  return (
    <div className="general-content-container">
      <h1 className="title-div">USER LIST</h1>
      <ListTable
        listId={TableDefinitions.USER_LIST_PAGE.id}
        loading={props.isLoading}
        columns={props.columns}
        data={props.data}
        keyField="id"
        downloadType={DownloadTypes.EXCEL}
        selectCheckbox
        pagination
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
  };
}

UserListingContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(UserListingContainer);
